/* FeedbackCollectorWrapper.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "._syazjjyb{color:var(--ds-text-subtle,#42526e)}";
const _10 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _9 = "._xtwz4jg8 h5{letter-spacing:normal}";
const _8 = "._5gkf1fw0 h5{font-weight:700}";
const _7 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _6 = "._4cvr1h6o{align-items:center}";
const _5 = "._1e0c1txw{display:flex}";
const _4 = "._vwz41k92{line-height:1.25rem}";
const _3 = "._otyr1ejb{margin-bottom:var(--ds-space-300,24px)}";
const _2 = "._1wyb1j6v{font-size:1rem}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button/standard-button';
import { AutoDismissFlag } from '@atlaskit/flag';
import FlagGroup from '@atlaskit/flag/flag-group';
import { N500 } from '@atlaskit/theme/colors';
import { BodySmall, FeedbackCollectorDialog, FinePrint } from '@atlassian/mpac-primitives';
import { FLAG_TYPE_SUCCESS } from '@atlassian/mpac-types';
import { useAtlaskitFlags } from '@atlassian/mpac-ui';
import { DOMUtils } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { usePrivacyAndSecurityAnalytics } from '../../hooks';
import { ContactPartnerLink } from '../ContactPartnerLink';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _ = "._1yt4ahf7{padding:0 var(--ds-space-300)}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4ahf7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const FeedbackTitleDetails = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1wyb1j6v _otyr1ejb _vwz41k92", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FeedbackTitleDetails.displayName = 'FeedbackTitleDetails';
}
const FeedbackCollectorSection = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o _zulpu2gc _5gkf1fw0 _xtwz4jg8", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FeedbackCollectorSection.displayName = 'FeedbackCollectorSection';
}
const FeedbackCollectorDescription = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = FinePrint,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pku2gc _syazjjyb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FeedbackCollectorDescription.displayName = 'FeedbackCollectorDescription';
}
const ActionContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _zulpu2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ActionContainer.displayName = 'ActionContainer';
}
const ActionButton = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = Button,
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syazjjyb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ActionButton.displayName = 'ActionButton';
}
// eslint-disable-next-line max-lines-per-function
export const FeedbackCollectorWrapper = _ref7 => {
  let {
    userId,
    feedbackGatewayBaseUrl,
    feedbackCollectorApiKeys,
    contactPartnerLinkProps
  } = _ref7;
  const {
    flags,
    addFlag,
    dismissFlag
  } = useAtlaskitFlags();
  const {
    fireFeedbackCollectorEvent,
    fireFeedbackCollectorSubmitEvent,
    fireFeedbackCollectorPopupCloseEvent
  } = usePrivacyAndSecurityAnalytics();
  const [feedbackDialogVisible, setFeedbackDialogVisible] = useState(false);
  const [isNoSelected, setIsNoSelected] = useState(false);
  const [isYesSelected, setIsYesSelected] = useState(false);
  const submit = feedbackValues => {
    setFeedbackDialogVisible(false);
    addFlag({
      id: Date.now().toString(),
      type: FLAG_TYPE_SUCCESS,
      title: 'Thank you for your response',
      description: 'Your opinion matters and will help us improve.',
      isAutoDismiss: true
    });
    fireFeedbackCollectorSubmitEvent(feedbackValues.type);
  };
  const close = () => {
    setFeedbackDialogVisible(false);
    fireFeedbackCollectorPopupCloseEvent();
  };
  const handleYes = () => {
    DOMUtils.scrollToDocumentTop();
    setFeedbackDialogVisible(true);
    setIsYesSelected(true);
    setIsNoSelected(false);
    fireFeedbackCollectorEvent(true);
  };
  const handleNo = () => {
    DOMUtils.scrollToDocumentTop();
    setFeedbackDialogVisible(true);
    setIsNoSelected(true);
    setIsYesSelected(false);
    fireFeedbackCollectorEvent(false);
  };
  const feedbackTitleDetails = /*#__PURE__*/_jsxs(FeedbackTitleDetails, {
    children: ["We are eager to hear your opinion. For any specific feedback on the responses,", ' ', /*#__PURE__*/_jsx(ContactPartnerLink, _objectSpread({}, contactPartnerLinkProps)), "."]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FeedbackCollectorDialog, {
      userId: userId,
      entrypointId: feedbackCollectorApiKeys.privacyAndSecurity.entrypointId,
      feedbackGatewayBaseUrl: feedbackGatewayBaseUrl,
      feedbackDialogVisible: feedbackDialogVisible,
      feedbackTitleDetails: feedbackTitleDetails,
      submitButtonLabel: "Send feedback",
      feedbackTitle: "Tell us about your experience",
      onClose: close,
      onSubmit: submit,
      anonymousFeedback: true,
      feedbackGroupLabels: {
        bug: {
          selectOptionLabel: 'Report incorrect information',
          fieldLabel: 'Describe the issue'
        },
        comment: {
          selectOptionLabel: 'Leave a comment',
          fieldLabel: 'Describe your experience'
        },
        suggestion: {
          selectOptionLabel: 'Suggest an improvement',
          fieldLabel: 'What would you like to improve?'
        },
        question: {
          selectOptionLabel: 'Ask a question',
          fieldLabel: 'What would you like to know?'
        },
        empty: {
          selectOptionLabel: "I'd like to...",
          fieldLabel: ''
        }
      }
    }), /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(FlagGroup, {
        onDismissed: dismissFlag,
        children: flags.map(flag => /*#__PURE__*/_jsx(AutoDismissFlag, _objectSpread({}, flag), flag.id))
      }), /*#__PURE__*/_jsxs(FeedbackCollectorSection, {
        children: [/*#__PURE__*/_jsx(BodySmall, {
          as: "h5",
          children: "Did you find this information useful?"
        }), /*#__PURE__*/_jsxs(ActionContainer, {
          children: [/*#__PURE__*/_jsx(ActionButton, {
            isSelected: isYesSelected,
            onClick: handleYes,
            children: "Yes"
          }), /*#__PURE__*/_jsx(ActionButton, {
            isSelected: isNoSelected,
            onClick: handleNo,
            children: "No"
          })]
        })]
      }), /*#__PURE__*/_jsx(FeedbackCollectorDescription, {
        children: "Atlassian will use this feedback to serve you better."
      })]
    })]
  });
};